/**
 * @flow
 * Created by neo on 01.06.17.
 */

import {observable} from 'mobx';
import FlightRoutePoint from './FlightRoutePoint';

export default class FlightRoute {
  @observable points: Array<FlightRoutePoint> = [];

  constructor(json?: any) {
    if(json) {
      this.points = (json.points || []).map(l => new FlightRoutePoint(l));
    }
  }
}



// WEBPACK FOOTER //
// ./src/App/Store/Flight/FlightRoute.js